import axios from 'axios';

const getEndpoint = () =>
  window.location.protocol === 'http:'
    ? 'http://localhost:5001'
    : `https://${window.location.host}/api`;

const authHeaders = () => {
  try {
    const userData = JSON.parse(sessionStorage.getItem('clinic-application-jwt'));
    return userData?.token ? { Authorization: `Bearer ${userData.token}` } : {};
  } catch (e) {
    return {};
  }
};

export const BUSINESS_TYPES = [
  { value: 'lab', label: 'Pathology Lab' },
  { value: 'diagnostic_centre', label: 'Diagnostic Centre' },
  { value: 'imaging', label: 'Imaging / Radiology' },
  { value: 'hospital', label: 'Hospital' },
  { value: 'pharmacy', label: 'Pharmacy' },
  { value: 'other', label: 'Other' },
];

export const businessTypeLabel = (value) =>
  BUSINESS_TYPES.find((type) => type.value === value)?.label || 'Other';

export const fetchReferralBusinesses = async (params = {}) => {
  const res = await axios.get(`${getEndpoint()}/referral-business`, { headers: authHeaders(), params });
  return { data: res?.data?.data || [], pagination: res?.data?.pagination || {} };
};

export const fetchReferralSuggestions = async (params = {}) => {
  const res = await axios.get(`${getEndpoint()}/referral-business/suggest`, { headers: authHeaders(), params });
  return res?.data?.data || [];
};

export const createReferralBusiness = async (payload) => {
  const res = await axios.post(`${getEndpoint()}/referral-business`, payload, { headers: authHeaders() });
  return res?.data?.data;
};

export const updateReferralBusiness = async (id, payload) => {
  const res = await axios.put(`${getEndpoint()}/referral-business/${id}`, payload, { headers: authHeaders() });
  return res?.data?.data;
};

export const deleteReferralBusiness = async (id) => {
  const res = await axios.delete(`${getEndpoint()}/referral-business/${id}`, { headers: authHeaders() });
  return res?.data;
};

export const fetchLabRequests = async (params = {}) => {
  const res = await axios.get(`${getEndpoint()}/referral-business/requests`, { headers: authHeaders(), params });
  return res?.data?.data || [];
};

export const resendLabRequest = async (id, payload = {}) => {
  const res = await axios.post(
    `${getEndpoint()}/referral-business/requests/${id}/resend`,
    { origin: window.location.origin, ...payload },
    { headers: authHeaders() }
  );
  return res?.data;
};

export const cancelLabRequest = async (id) => {
  const res = await axios.post(`${getEndpoint()}/referral-business/requests/${id}/cancel`, {}, { headers: authHeaders() });
  return res?.data;
};

export const labDocumentUrl = (documentId) => `${getEndpoint()}/patient-documents/${documentId}/file`;

export const openLabDocument = async (documentId) => {
  const res = await axios.get(labDocumentUrl(documentId), { headers: authHeaders(), responseType: 'blob' });
  const url = URL.createObjectURL(res.data);
  window.open(url, '_blank', 'noopener');
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};

/* public, no login: the token in the URL is the only credential */

export const fetchLabUploadContext = async (token) => {
  const res = await axios.get(`${getEndpoint()}/lab-upload/public/${token}`);
  return res?.data?.data;
};

export const uploadLabReports = async (token, files, notes = '') => {
  const form = new FormData();
  Array.from(files).forEach((file) => form.append('files', file));
  if (notes) form.append('notes', notes);

  const res = await axios.post(`${getEndpoint()}/lab-upload/public/${token}`, form);
  return res?.data;
};
